import { useParams } from 'react-router-dom';
import { useGetVehicleByIdQuery } from '../../../../services/api/upload-vehicle';

export const useViewedVehicle = () => {
  const { id: vehicleId } = useParams<{ id: string }>();
  const { data: vehicle } = useGetVehicleByIdQuery(Number(vehicleId));

  return vehicle;
};
